export class AuditTermsOfUseLog{

    version:number; 
    action:string;
   
}


// WEBPACK FOOTER //
// ./src/app/modules/terms-of-use/entity/audit-terms-of-use-log.ts